module.exports = __webpack_public_path__ + "img/app_store_seek.5fc79cc4.jpg";